import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import toy from "../../assets/toy.png";
import bag from "../../assets/bag.png";
import language from "../../assets/language.png";
import pen from "../../assets/pen.png";
import "./ChooseStageContainer.css";
function ChooseStageContainer() {
  const { stgeesArray } = useSelector((state) => state.stages);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const departmentTranslations = {
    "قسم الاساسي ( من الصف الاول الى الصف العاشر)": {
      en: "Basic Section",
      img: bag
    },
    'قسم ما بعد الأساسي( من الصف الحادي عشر الى الصف الثاني عشر)': {
      en: "Post Basic Section",
      img: pen
    },

    "قسم التعليم المبكر ( رياض الأطفال)": {
      en: "Early Childhood Section (Kindergarten)",
      img: toy
    },
    "قسم ثنائي اللغة": {
      en: "Bilingual Section",
      img: language
    }
  };


  // const withEnglish = stgeesArray.map(item => ({
  //   ...item,
  //   label_en: departmentTranslations[item.label] || item.label,
  //     image: departmentTranslations[item.label]?.img || null


  // }));

  const withEnglish = stgeesArray.map(item => {
    const translation = departmentTranslations[item.label];
    console.log(translation,"trandksfjlkdsjfksdslation");


    return {
      ...item,
      label_en: translation?.en || item.label,
      image: translation?.img || null,
    };
  });
console.log("withEnglish",withEnglish);

  return (
    <div className='mb-5 pt-5 choose_stage_container'>
      <h4 className='text_main fw-bold mb-3 pt-5'>{currentLocal.home.newStudentTitle}</h4>
      <ol>
        {currentLocal.home.registrationTerms.map((term, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: term }}></li>
        ))}
      </ol>

      <div className='mt-4'>
        <h4 className='text_main fw-bold my-3'>{currentLocal.home.newStudentSelectGrade}</h4>
        <Row>
          {withEnglish?.map((item) => {
            console.log(item);

            return (
              <Col md={6}>
                <Link to={`/student/${item?.value}`}>
                  <div className='feature_card rounded px-3 py-4 mb-3 rounded'>
                    <div className='d-flex justify-content-center mb-4'>
                      <img src={item?.image} alt='' className='w-25' />
                    </div>
                    <p className='feature_card_title'>{currentLocal.language == "العربيه" ? item?.label : item.label_en}</p>
                  </div>
                </Link>
                {/* <div className='d-flex justify-content-center rounded mb-3 py-5'style={{
                      boxShadow: "0px 5px 0px 0px rgba(229, 229, 229, 0.75)"

            }}>
              <Link to={`/student/${item?.value}`}className='py-5'>
                <div className='d-flex justify-content-center mb-4'>
    <img src={item?.image}alt=''className='w-25'/>
  </div>
                <p className='text-muted fw-bold'>{currentLocal.language=="العربيه"?item?.label:item.label_en}</p>
              </Link>
            </div> */}
              </Col>
            )
          })}


        </Row>
      </div>
    </div>
  )
}

export default ChooseStageContainer